import React, { useEffect } from "react";
import Template from "../components/Template";
import loginImg from "../assets/login.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Loader from "../components/Loader";
const Login = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      setIsLoggedIn(true);
      navigate("/dashboard");
    } else {
      setIsLoggedIn(false);
      navigate("/login");
    }
    setTimeout(() => {
      setLoading(false); // Simulating data loaded, set loading to false
    }, 500);
  }, [navigate, setIsLoggedIn]);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Template
          title="Welcome Back"
          desc1="Only accept products with an authentication sticker"
          desc2="Only buy from authorized retailers"
          image={loginImg}
          formtype="login"
          setIsLoggedIn={setIsLoggedIn}
        />
      )}
    </div>
  );
};

export default Login;
